var map = {
	"./404.svg": "sEM+",
	"./approve.svg": "VHlD",
	"./bug.svg": "SVqS",
	"./chart.svg": "RjYk",
	"./chazhao.svg": "s/XM",
	"./clipboard.svg": "KO/S",
	"./component.svg": "s2cW",
	"./dashboard.svg": "BCGP",
	"./documentation.svg": "zUKd",
	"./drag.svg": "vRhf",
	"./edit.svg": "ql+d",
	"./email.svg": "+4G4",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./group_02.svg": "YmaR",
	"./guide.svg": "z74U",
	"./icon.svg": "vUvT",
	"./international.svg": "SBEl",
	"./language.svg": "+Dip",
	"./list.svg": "vuHp",
	"./lock.svg": "FnAU",
	"./lock01.svg": "gjN0",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./nested.svg": "798r",
	"./org01.svg": "JiKO",
	"./password.svg": "QjmH",
	"./password_02.svg": "hiwM",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./qq.svg": "R2jY",
	"./reject.svg": "Mql9",
	"./shoppingCard.svg": "dNDk",
	"./shu.svg": "PDl3",
	"./star.svg": "60zo",
	"./suo.svg": "L/c7",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./theme.svg": "hdtf",
	"./tianjia.svg": "hzu9",
	"./tree.svg": "3eCm",
	"./tupian.svg": "nzcT",
	"./user.svg": "VdD3",
	"./user01.svg": "5edD",
	"./user_02.svg": "udQC",
	"./wechat.svg": "pYJ+",
	"./yonghu.svg": "qRd6",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 22